/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 20/10/2022
 */
import BaseObject from "@shared/BaseObject.js";
import {clientEmailPickerDialog} from "@/core/components/Picker/ClientPickerView/dialog";
import {MessagePlaceholdersEnum} from "@/core/components/template/PlaceholdersData";
import {asSingleElement, generateLink} from "@/utils/helpers";
import {yesNoDialog} from "@/core/components/Dialogs/dialog.js";
import {ProfileTypeEnum} from "@shared/Profile/ProfileTypeEnum";
import RecipientItem from "@shared/Profile/RecipientItem";
import SenderItem from "@shared/Profile/SenderItem";

export default class NotificationHelper extends BaseObject {

	dataManager
	vueComponent

	constructor(vueComponent) {
		super();
		this.dataManager = vueComponent.dataManager
		this.vueComponent = vueComponent
	}

	async sendTeamEmailClientAssigned(memberProfile, options = {}){
		let {clientProfile} = options
		let portalLink = generateLink("ClientDetailsMain", {clientProfileId: clientProfile.id})
		return this.sendGeneralEmail(memberProfile, {
			...options,
			profileTitle: "team member",
			subject: "You've been assigned a new client",
			body: `Hi ${memberProfile.getFirstName()},
			<br/><br/>
			You've been assigned ${clientProfile.name} as a new client.
			<br/><br/>
			You can find them in your portal using the link below:
			<br/><br/>
			<a href="${portalLink}" target="_blank">Open portal</a>
			<br/><br/>
			Kind Regards,
			<br/>
			${this.getOwnerProfile().getFirstName()}`,
			tokens: [],
		})
	}
	async sendTeamEmailClientUnassigned(memberProfile, options = {}){
		if(!Array.isArray(memberProfile)){
			memberProfile = [memberProfile]
		}
		let {clientProfile} = options
		let memberName = memberProfile.length === 1 ? memberProfile[0].getFirstName() : null
		let firstNameToken = memberName ? null : MessagePlaceholdersEnum.INVITEE_FIRST_NAME
		let portalLink = generateLink("ClientListMainRoute", {clientProfileId: clientProfile.id})

		options.data
		return this.sendGeneralEmail(memberProfile, {
			...options,
			profileTitle: "team member",
			subject: "You've been unassigned from a client",
			body: `Hi ${memberName ||  firstNameToken},
			<br/><br/>
			You've been unassigned from ${clientProfile.name}.
			<br/><br/>
			You can find your current clients in your portal using the link below:
			<br/><br/>
			<a href="${portalLink}" target="_blank">Open portal</a>
			<br/><br/>
			Kind Regards,
			<br/>
			${this.getOwnerProfile().getFirstName()}`,
			tokens: [firstNameToken].filter(item => !!item),
		})
	}

	async sendClientEmailCoachAssigned(memberProfile, options = {}){
		let {clientProfile} = options
		let {portalLink} = this.getMessageParams(clientProfile)
		return this.sendGeneralEmail(clientProfile, {
			...options,
			profileTitle: "client",
			subject: "You've been assigned a new coach",
			body: `Hi ${clientProfile.getFirstName()},
			<br/><br/>
			You've been assigned ${memberProfile.name} as your coach.
			<br/><br/>
			You can find them in your portal using the link below:
			<br/><br/>
			<a href="${portalLink}" target="_blank">Open portal</a>
			<br/><br/>
			Kind Regards,
			<br/>
			${this.getOwnerProfile().name}`,
			tokens: [],
		})
	}

	sendTeamEmailResourcesAssigned(memberProfile, options = {}){
		let portalLink = generateLink("ResourcesRoot")
		return this.sendGeneralEmail(memberProfile, {
			...options,
			profileTitle: "team member",
			subject: "You've been assigned new resources",
			body: `Hi ${memberProfile.getFirstName()},
			<br/><br/>
			You've been assigned new resources.
			<br/><br/>
			You can find them in your portal using the link below:
			<br/><br/>
			<a href="${portalLink}" target="_blank">Open portal</a>
			<br/><br/>
			Kind Regards,
			<br/>
			${this.getOwnerProfile().getFirstName()}`,
			tokens: [],
		})

	}

	getOwnerProfile(){
		return this.vueComponent.userProfile
	}


	async sendGeneralEmail(clientProfile, options = {}){
		let {subject, body, tokens, profileTitle, emailData: emailDataLocal = {}} = options
		//profileTitle - i.e. "Client" in the "Select Client" title
		// let {subject, body} = this.getGeneralEmailSubjectAndBody(clientProfile)
		let emailData = await clientEmailPickerDialog({
			clientProfile: clientProfile,
			clientProfileReadonly: !!clientProfile,
			profileTitle: profileTitle,
			emailSubject: subject,
			emailBody: body,
			onOkLoadingText: "Sending email...",
			title: "Compose message for",
			okTitle: "Send Email",
			cancelTitle: "Skip",
			actionOk: async (data) => {
				let missingTokens = this.validateEmailData(data, tokens)
				if(missingTokens.length){
					let res = await this.showMissingTokensDialog(missingTokens)
					if(!res){
						return false
					}
				}
				Object.assign(data.emailData, emailDataLocal)
				await this.sendNotificationEmail(data.emailData)
				this.vueComponent.toast("Email was sent successfully")
			}
		})

		if(emailData){
			return true
		}

		return false
	}

	//show messageDialog that lists missing tokens from the missingTokens array
	async showMissingTokensDialog(missingTokens){
		let message = "Some required tokens are missing. Please make sure the following parts of the message are presented in the message and are not altered:<br/><br/>"
		for(let token of missingTokens){
			message += `<div class="bold">${token}</div>`
		}
		message += "<br/><br/><span class='text-danger'>Proceeding will result in a corrupted message.</span>"

		message += "<br/>Do you want to proceed anyway?"
		let res = yesNoDialog({
			title: "WARNING: Missing tokens",
			message: message,
			cancelTitle: "Proceed anyway",
			okTitle: "Fix it"
		})
		return !res
	}

	//requiredTokensArray is an array of strings. Check is all strings form the array are presented in email data message and return missing tokens
	validateEmailData(data, requiredTokensArray){
		console.log("NotificationHelper.validateEmailData: ", arguments)
		let {emailData} = data
		let missingTokens = []
		if(requiredTokensArray){
			for(let token of requiredTokensArray){
				if(!emailData.body || !emailData.body.includes(token)){
					missingTokens.push(token)
				}
			}
		}
		return missingTokens
	}

	async emailNotifyResourcesShared(clientProfile, options = {}){

		let clientLimit = options.clientLimit || 1
		let packageItem = options.packageItem || null
		let isGroupSharing = options.isGroupSharing
		let onOk = options.onOk || (async () => {})

		let readonly = options.readonly !== undefined ? options.readonly : (!!clientProfile || Array.isArray(clientProfile))

		let {subject, body} = this.getResourceSharedSubjectAndBody(clientProfile)

		// let clientLimit = Array.isArray(clientProfile) ? clientProfile.length : 1

		let emailData = await clientEmailPickerDialog({
			clientProfile: clientProfile,
			clientProfileReadonly: readonly,
			clientLimit: clientLimit,
			emailSubject: subject,
			emailBody: body,
			onOkLoadingText: "Sending notification...",
			title: "Notification message",
			okTitle: "Send Notification",
			cancelTitle: "Skip",
			actionOk: async (data) => {
				await onOk(data)
				await this.sendNotificationEmail(data.emailData)
			}
		})

		if(emailData){
			return true
		}

		return false
	}

	async emailNotifyCoachResourcesShared(clientProfile){

		let clientId = clientProfile.id
		let clientName = clientProfile.name
		let coachId = this.vueComponent.coachProfile.id
		let coachName = this.vueComponent.coachProfile.name
		// let email = this.vueComponent.coachProfile.email

		let recipients = clientProfile.assignedTo.map(shortProfile => {
			let recipientItem = new RecipientItem()
			recipientItem.id = shortProfile.id
			recipientItem.name = shortProfile.name
			recipientItem.profileType = ProfileTypeEnum.TEAM_MEMBER
			return recipientItem
		})


		let sender = new SenderItem()
		sender.name = "Qwoach Team",
		sender.profileType = ProfileTypeEnum.QWOACH_PLATFORM

		let ownerId = this.vueComponent.ownerProfileId

		let {subject, body} = this.getResourceSharedSubjectAndBodyByClient(clientProfile)

		let emailData = {ownerId, clientId, clientName, coachId, coachName, subject, body, recipients, sender}

		await this.sendNotificationEmail(emailData)
		// let clientLimit = Array.isArray(clientProfile) ? clientProfile.length : 1

		return true
	}

	async emailResendContractReminder(clientProfile, legalDoc, options = {}){

		let onBeforeSend = options.onBeforeSend || (() => {})
		let okTitle = options.okTitle || "Send Notification"
		let title = options.title || "Compose message"

		let {subject, body} = this.getSignContractReminderSubjectAndBody(clientProfile, legalDoc)

		let emailData = await clientEmailPickerDialog({
			clientProfile: clientProfile,
			clientProfileReadonly: !!clientProfile,
			emailSubject: subject,
			emailBody: body,
			onOkLoadingText: "Sending notification...",
			title: title,
			okTitle: okTitle,
			actionOk: async (data) => {
				await onBeforeSend()
				await this.sendNotificationEmail(data.emailData)
			}
		})

		if(emailData){
			return true
		}

		return false
	}

	async emailSendGroupContract(clientProfile, legalDocTemplate, packageItem, options = {}){

		let onBeforeSend = options.onBeforeSend || (() => {})
		let okTitle = options.okTitle || "Send Notification"
		let title = options.title || "Compose message"
		let extraMessage = options.extraMessage

		let emailSubjectBodyData = this.getSignContractGroupSubjectAndBody(clientProfile, legalDocTemplate, packageItem)
		let {subject, body, data} = emailSubjectBodyData
		console.log("emailSubjectBodyData = ", emailSubjectBodyData)

		let emailData = await clientEmailPickerDialog({
			clientProfile: clientProfile,
			clientProfileReadonly: !!clientProfile,
			emailSubject: subject,
			emailBody: body,
			extraMessage: extraMessage,
			onOkLoadingText: "Sending notification...",
			title: title,
			okTitle: okTitle,
			actionOk: async (dataLocal) => {
				await onBeforeSend()

				let emailData = dataLocal.emailData
				emailData.data = data

				let legalDocLinkHtml = `<a href="${emailData.data.legalDocLink}" target="_blank">View now</a>`
				emailData.body = emailData.body.split("{{legalDocLink}}").join(legalDocLinkHtml)
				await this.sendNotificationEmail(dataLocal.emailData)
			}
		})

		if(emailData){
			return true
		}

		return false
	}


	async sendNotificationEmail(emailData){
		if(emailData.clientDataArray){
			return this.sendNotificationEmailMultiple(emailData)
		}
		return await this.dataManager.apiPostSendNotificationEmail(emailData)
	}

	async sendNotificationEmailMultiple(emailData){
		return await this.dataManager.apiPostSendNotificationEmailMultiple(emailData)
	}

	getMessageParams(clientProfile){

		let isArray = Array.isArray(clientProfile)

		let coachProfile = this.vueComponent.coachProfile
		let ownerProfile = this.vueComponent.ownerProfile

		let clientName = !isArray && clientProfile?.getFirstName() || MessagePlaceholdersEnum.CLIENT_FIRST_NAME
		let clientFullName = !isArray && clientProfile?.name || MessagePlaceholdersEnum.CLIENT_FULL_NAME
		let coachName = coachProfile?.getFirstName() || MessagePlaceholdersEnum.COACH_FIRST_NAME
		let coachFullName = coachProfile?.name || MessagePlaceholdersEnum.COACH_FULL_NAME

		let inviteId =  this.vueComponent.dataManager.generateId()
		let portalLink = generateLink("ClientPortalMain")
		if(!isArray && clientProfile) {
			if (!clientProfile.isInviteAccepted()) {
				portalLink = generateLink("ClientInvite", {
					coachId: ownerProfile?.id,
					clientId: clientProfile.id,
					teamMemberId: coachProfile?.id,
				})
			}
		}
		let coachPortalLink = generateLink("ClientDetailsMain", {clientProfileId: clientProfile?.id})

		portalLink = this.vueComponent.getBrandedLink(portalLink)

		return {clientName, clientFullName, coachName, coachFullName, portalLink, coachPortalLink, inviteId}
	}

	getPackageInviteLink(packageTemplate, extraQuery){
		return generateLink("CoachingPackageJoin", {coachId: packageTemplate.coachId, packageId: packageTemplate.id}, null, extraQuery)
	}
	getGroupPackageInviteLink(packageTemplate, extraQuery){
		return generateLink("CoachingPackageGroupJoin", {coachId: packageTemplate.coachId, packageId: packageTemplate.id}, null, extraQuery)
	}

	getResourceSharedSubjectAndBody(clientProfile){

		let {clientName, coachName, portalLink} = this.getMessageParams(clientProfile)

		let subject = "New resources"
		let body = `Hi ${clientName},
		<br/><br/>
		I've just added a few relevant resources for you that I believe you'll find helpful
		<br/><br/>
		You can find them in your portal using the link below:
		<br/><br/>
		<a href="${portalLink}" target="_blank">Open portal</a>
		<br/><br/>
		Kind Regards,
		<br/>
		${coachName}`
			.replaceAll("\n", "")

		return {subject, body}
	}

	getResourceSharedSubjectAndBodyByClient(clientProfile){

		let {clientName, clientFullName, coachName, coachFullName, portalLink, coachPortalLink} = this.getMessageParams(clientProfile)

		let subject = "Resources added by your client"
		let body = `Hi {{recipientName}},
		<br/><br/>
		Your client ${clientFullName} has just added one or more resources into their portal.
		<br/><br/>
		You can find them under your portal using the link below:
		<br/><br/>
		<a href="${coachPortalLink}" target="_blank">Open portal</a>
		<br/><br/>
		Kind Regards,
		<br/>
		Qwoach Team
		<br/><br/>This is an automated message. Please do not reply to this email.`

		return {subject, body}
	}

	getSignContractReminderSubjectAndBody(clientProfile, legalDoc){

		let {clientName, coachName} = this.getMessageParams(clientProfile)
		let legalDocLink = generateLink("SignDocumentPath", {coachId: legalDoc.coachId, documentId: legalDoc.id})

		let data = {
			legalDocName: legalDoc.name,
			legalDocLink: legalDocLink,
			coachName: coachName
		}

		let subject = `Signature request for '${legalDoc.name}'`
		let body = `Hi ${clientName},
		<br/><br/>
		Please take a moment to complete '${legalDoc.name}' before our next session.
		<br/><br/>
		<a href="${legalDocLink}" target="_blank">Click to sign now</a>
		<br/><br/>
		Kind Regards,<br/>
		${coachName}`

		return {subject, body, data}
	}


	getSignContractGroupSubjectAndBody(clientProfiles, legalDocTemplate, packageItem){

		let {clientName, coachName} = this.getMessageParams(clientProfiles)
		let legalDocLink = generateLink("SignDocumentPath", {coachId: legalDocTemplate.coachId, documentId: legalDocTemplate.id}, {packageId: packageItem.id}, {clientId: "{{clientId}}"})

		let data = {
			legalDocName: legalDocTemplate.name,
			legalDocLink: legalDocLink,
			coachName: coachName
		}

		let subject = `Signature request for '${legalDocTemplate.name}'`
		let body = `Hi ${clientName},
		<br/><br/>
		Please take a moment to complete '${legalDocTemplate.name}' before our next session.
		<br/><br/>
		{{legalDocLink}}
		<br/><br/>
		Kind Regards,<br/>
		${coachName}`

		return {subject, body, data}
	}

	getGeneralEmailSubjectAndBody(clientProfile){

		let {clientName, coachName, portalLink} = this.getMessageParams(clientProfile)

		let subject = ""
		let body = `Hi ${clientName},

		Kind Regards,
		${coachName}`

		return {subject, body}
	}

	getGroupInviteSubjectAndBody(groupPackage){
		return this.getTemplateInviteSubjectAndBody(groupPackage, {canScheduleSessions: false, isGroupInvite: true})
	}

	getTemplateInviteSubjectAndBody(template, options = {}){

		let clientProfile = options.clientProfile
		let canScheduleSessions = options.canScheduleSessions == null ? true : options.canScheduleSessions
		let extraQuery = {clientId: "{{clientId}}"}
		let inviteLink = options.isGroupInvite ? this.getGroupPackageInviteLink(template, extraQuery) : this.getPackageInviteLink(template, extraQuery)

		let {clientName, coachName, portalLink} = this.getMessageParams(clientProfile)
		// let inviteLink = this.getPackageInviteLink(template)

		let sessionCount = canScheduleSessions ? template.totalSessionsCount() : 0
		let legalDocsCount = template.welcomeMaterials.getLegalDocTemplatesFileRefs().length
		let welcomeDocsCount = template.welcomeMaterials.getNonLegalDocsFileRefs().length

		let hasAnything = sessionCount || legalDocsCount || welcomeDocsCount
		let hasDocs = legalDocsCount || welcomeDocsCount
		let sessionAndDocsConnector = sessionCount && hasDocs ? " as well as" : ""
		let docsConnector = legalDocsCount && welcomeDocsCount ? " and" : ""
		let instructionsMessage = hasAnything ? "After you join," : ""

		if(sessionCount){
			instructionsMessage += " you'll be able to schedule your first session"
		}
		instructionsMessage += sessionAndDocsConnector

		if(hasDocs){
			instructionsMessage += " you'll receive"
		}

		if(legalDocsCount){
			instructionsMessage += " legal documents to sign"
		}
		instructionsMessage += docsConnector

		if(welcomeDocsCount){
			instructionsMessage += " your initial materials"
		}

		if(instructionsMessage) {
			instructionsMessage += ".<br/><br/>"
		}


		let subject = `Invitation to join "${template.title}"`


		let body = `Hi ${clientName},
		<br/><br/>
		Please use the link below to join me in "${template.title}":
		<br/><br/>
		<a href="${inviteLink}" target="_blank">Join ${template.title}</a>
		<br/><br/>
		${instructionsMessage}
		Kind Regards,
		<br/>
		${coachName}`

		return {subject, body}
	}

	// getTemplateGroupInviteSubjectAndBody(template, clientProfile){
	//
	// 	let {clientName, coachName, portalLink} = this.getMessageParams(clientProfile)
	// 	let inviteLink = this.getPackageInviteLink(template)
	//
	// 	let sessionCount = 0//template.totalSessionsCount()
	// 	let legalDocsCount = template.welcomeMaterials.getLegalDocTemplatesFileRefs().length
	// 	let welcomeDocsCount = template.welcomeMaterials.getNonLegalDocsFileRefs().length
	//
	// 	let hasAnything = sessionCount || legalDocsCount || welcomeDocsCount
	// 	let hasDocs = legalDocsCount || welcomeDocsCount
	// 	let sessionAndDocsConnector = sessionCount && hasDocs ? "as well as " : ""
	// 	let docsConnector = legalDocsCount && welcomeDocsCount ? "and " : ""
	// 	let instructionsMessage = hasAnything ? "After you join, " : ""
	//
	// 	if(sessionCount){
	// 		instructionsMessage += "you'll be able to schedule your first session "
	// 	}
	// 	instructionsMessage += sessionAndDocsConnector
	//
	// 	if(hasDocs){
	// 		instructionsMessage += "you'll receive "
	// 	}
	//
	// 	if(legalDocsCount){
	// 		instructionsMessage += "legal documents to sign "
	// 	}
	// 	instructionsMessage += docsConnector
	//
	// 	if(welcomeDocsCount){
	// 		instructionsMessage += "your initial materials "
	// 	}
	//
	// 	instructionsMessage += "."
	//
	//
	// 	let subject = `Invitation to join "${template.title}"`
	//
	//
	// 	let body = `Hi ${clientName},
	//
	// 	Please use the link below to join me in '${template.title}':
	//
	// 	<a href="${inviteLink}" target="_blank">Join ${template.title}</a>
	//
	// 	${instructionsMessage}
	//
	// 	Kind Regards,
	// 	${coachName}`
	//
	// 	return {subject, body}
	// }

	getTemplateWelcomeSubjectAndBody(template, clientProfile){

		let {clientName, coachName, portalLink} = this.getMessageParams(clientProfile)

		let sessionCount = template.totalSessionsCount()
		let instructionsMessage = ""

		if(sessionCount){
			instructionsMessage = "You can also schedule your first session right from your portal below."
		}


		let subject = `Invitation to join "${template.title}"`


		let body = `Hi ${clientName},
		<br/><br/>
		I'm really excited to work with you.
		<br/><br/>
		Please review and complete the agreement below before our first session (click them to sign):
		<br/><br/>
		{{legal_docs}}
		<br/><br/>
		Here is also some initial materials to help you get started (click them to view):
		<br/><br/>
		{{attached_files}}
		<br/><br/>
		${instructionsMessage}
		<br/><br/>
		<a href="${portalLink}" target="_blank">Open my portal</a>
		<br/><br/>
		Kind Regards,
		<br/>
		${coachName}`

		return {subject, body}
	}

	getTaskSharedSubjectAndBody(clientProfile){
		let {clientName, coachName, portalLink} = this.getMessageParams(clientProfile)

		let subject = "New task"
		let body = `Hi ${clientName},
		<br/><br/>
		I've just added a task for you.
		<br/><br/>
		You can find it in your portal using the link below:
		<br/><br/>
		<a href="${portalLink}" target="_blank">Open portal</a>
		<br/><br/>
		Kind Regards,
		<br/>
		${coachName}`

		return {subject, body}
	}

	getNoteSharedSubjectAndBody(clientProfile){
		let {clientName, coachName, portalLink} = this.getMessageParams(clientProfile)

		let subject = "New note"
		let body = `Hi ${clientName},
		<br/><br/>
		I've just added a note for you.
		<br/><br/>
		You can find it in your portal using the link below:
		<br/><br/>
		<a href="${portalLink}" target="_blank">Open portal</a>
		<br/><br/>
		Kind Regards,
		<br/>
		${coachName}`

		return {subject, body}
	}

	getWorksheetSharedSubjectAndBody(clientProfile){
		let {clientName, coachName, portalLink} = this.getMessageParams(clientProfile)

		let subject = "New worksheet"
		let body = `Hi ${clientName},
		<br/><br/>
		I've just added a worksheet for you.
		<br/><br/>
		You can find it in your portal using the link below:
		<br/><br/>
		<a href="${portalLink}" target="_blank">Open portal</a>
		<br/><br/>
		Kind Regards,
		<br/>
		${coachName}`

		return {subject, body}
	}
}
